import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetDailyDepositSalesParams,
  getDailyDepositSales,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const ReportDailyDepositSales: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validOnEmpty
      onRefresh={(output, params, startDateInterval, endDateInterval) => {
        const getDailyDepositSalesParams: GetDailyDepositSalesParams = {
          output,
          beginDate: startDateInterval.format("MM/DD/YYYY"),
          endDate: endDateInterval.format("MM/DD/YYYY"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getDailyDepositSalesParams[id] = params.id;
        }

        return getDailyDepositSales(getDailyDepositSalesParams);
      }}
    />
  );
};

export default ReportDailyDepositSales;
